
import { Box, Button, Radio, TextField, Typography, Tooltip } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Fileupload from "../FileuploadWithPreview/Fileupload";
import plus from "../../../src/assests/images/plus_red.svg";
import trash from "../../../src/assests/images/trash.svg";
import cancel from "../../../src/assests/images/close-circle.svg";
import galleryaddred from "../../../src/assests/images/galleryred.svg";
import galleryadd from "../../../src/assests/images/gallery-add.svg";
import InstructionOne from "./InstructionOne";
import { useTaskContext } from "../store/AlltasksContext";
import { uploadimagetask } from "../../pages/create-task/api";
import { getToken } from "../../utils/utils";
import CreatetaskImg from "../FileuploadWithPreview/createtask-img";
import CreatetaskImg3 from "../FileuploadWithPreview/createtask-imgthree";

interface MulitipleItem {
  id: number;
  value: string;
  value_hi: string;
  checkvalue: string;
  smallimage: string;
  bigimage: string;
  mainid: number;
  ismatch: boolean;
}

interface BannerProps {
  title: string;
  uploadText: string;
  uploadSize: string;
  imageUrls: string;
  maintitle: string;
  setuploadedImage: (image: string) => void;
}

interface MultipleChoiceProps {
  initialMultiplies: MulitipleItem[];
  placeholderPrefix: string;
  idid: number;
  textvalue: string;
  sectionsData1: number;
  updateSectionsData: (sectionId: number, updatedMultiples: MulitipleItem[]) => void;
  index: number;
  updateSectionsData1: (sectionId: number, index: number, text: string) => void;
  updateSectionsData345: (sectionId: number, test22: string) => void;
  test22: string;
  setIconImage?: React.Dispatch<React.SetStateAction<string>>;
  iconImage?: string;
  lang: {
    addInstruction: string;
    writeHintCorrectOption: string;
    instruction: string;
    addOptions: string;
    selectCorrectOptionHint: string;
  };
  bannerProps?: Partial<BannerProps>;
}

const MulitipleChoice: React.FC<MultipleChoiceProps> = ({
  initialMultiplies = [
    { id: 1, value: "", value_hi: "", checkvalue: "check1", smallimage: "", bigimage: "", mainid: 0, ismatch: false },
    { id: 2, value: "", value_hi: "", checkvalue: "check2", smallimage: "", bigimage: "", mainid: 0, ismatch: false },
    { id: 3, value: "", value_hi: "", checkvalue: "check3", smallimage: "", bigimage: "", mainid: 0, ismatch: false },
    { id: 4, value: "", value_hi: "", checkvalue: "check4", smallimage: "", bigimage: "", mainid: 0, ismatch: false },
  ],
  placeholderPrefix = "Instruction",
  idid,
  textvalue,
  sectionsData1,
  updateSectionsData,
  updateSectionsData1,
  updateSectionsData345,
  lang,
  test22,
  index,
  setIconImage,
  bannerProps,
  iconImage,
}) => {
  const [multiples, setMultiples] = useState<MulitipleItem[]>(() => {
    const base = initialMultiplies.length > 1 ? initialMultiplies : [
      { id: 1, value: "", value_hi: "", checkvalue: "check1", smallimage: "", bigimage: "", mainid: idid, ismatch: false },
      { id: 2, value: "", value_hi: "", checkvalue: "check2", smallimage: "", bigimage: "", mainid: idid, ismatch: false },
      { id: 3, value: "", value_hi: "", checkvalue: "check3", smallimage: "", bigimage: "", mainid: idid, ismatch: false },
      { id: 4, value: "", value_hi: "", checkvalue: "check4", smallimage: "", bigimage: "", mainid: idid, ismatch: false },
    ];
    return base.map(item => ({ ...item, mainid: idid }));
  });

  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [selectedLabel, setSelectedLabel] = useState<string | null>(null);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [imageMap, setImageMap] = useState<Record<number, { bigimage: string[]; smallimage: string[] }>>({});
  const [text, setText] = useState("");
  const { Tabname, activeStep, allinone, selectedmcq, setstep1data2 ,step1data2,correctHintArray, setCorrectHintArray,setCorrectHintHiArray, correctHintHiArray,} = useTaskContext();
console.log(step1data2, "step1data2ssssssssssss")
  const prevMultiplesRef = useRef<MulitipleItem[]>(multiples);
  const prevTextRef = useRef<string>(text);

  useEffect(() => {
    if (JSON.stringify(prevTextRef.current) !== JSON.stringify(text)) {
      updateSectionsData1(idid, index, text);
      prevTextRef.current = text;
    }
  }, [text, idid, index, updateSectionsData1]);

  useEffect(() => {
    if (JSON.stringify(prevMultiplesRef.current) !== JSON.stringify(multiples)) {
      updateSectionsData(idid, multiples);
      setstep1data2((prevSections: any[]) => {
        return prevSections.map((section) =>
          section.id === idid ? { ...section, Multiples: multiples } : section
        );
      });
      prevMultiplesRef.current = multiples;
    }
  }, [multiples, idid, updateSectionsData, setstep1data2]);
console.log(allinone, "allinoneeeeeeeeeeee",step1data2)
useEffect(() => {
  const question = allinone.find((q) => q.question_no === idid);
  if (question && question.options) {
    const prefilledMultiples = question.options.map((option: any, index: number) => ({
      id: option.option_id,
      value: option.option_value_en || "",
      value_hi: option.option_value_hi || "",
      checkvalue: `check${index + 1}`,
      smallimage: option.option_small_img || "",
      bigimage: option.option_big_img || "",
      mainid: idid,
      ismatch: option.correct_option === "1",
    }));

    setMultiples((prev) => {
      if (prev.every((item) => !item.value && !item.value_hi && !item.smallimage && !item.bigimage)) {
        return prefilledMultiples;
      }
      return prev;
    });

    const newImageMap = prefilledMultiples.reduce(
      (acc: any, item: { bigimage: string; smallimage: string; id: any }) => {
        const bigImages = item.bigimage ? item.bigimage.split(",") : [];
        const smallImages = item.smallimage ? item.smallimage.split(",") : [];
        return {
          ...acc,
          [item.id]: {
            bigimage: bigImages,
            smallimage: smallImages,
          },
        };
      },
      {}
    );
    setImageMap(newImageMap);

    const correctOption = prefilledMultiples.find((item: { ismatch: any }) => item.ismatch);
    if (correctOption) {
      setSelectedValue(String(correctOption.id));
      setSelectedLabel(correctOption.value);
      setSelectedId(correctOption.id);
    }

    setstep1data2((prevSections: any[]) => {
      const exists = prevSections.some((section) => section.id === idid);
      const sectionData = {
        id: idid,
        question_id: question.question_id, // <-- add this line
        Multiples: prefilledMultiples,
      };
      if (!exists) {
        return [...prevSections, sectionData];
      }
      return prevSections.map((section) =>
        section.id === idid ? { ...section, ...sectionData } : section
      );
    });
  }
}, [idid, allinone, setstep1data2]);

  const handleTextFieldChange = (id: number, newValue: string) => {
    setMultiples((prev) => {
      const updatedMultiples = prev.map((item) =>
        item.id === id
          ? {
              ...item,
              value: activeStep === 1 ? newValue : item.value,
              value_hi: activeStep === 2 ? newValue : item.value_hi,
              mainid: idid,
            }
          : item
      );

      setstep1data2((prevSections: any[]) => {
        const exists = prevSections.some((section) => section.id === idid);
        if (!exists) {
          return [...prevSections, { id: idid, Multiples: updatedMultiples }];
        }
        return prevSections.map((section) =>
          section.id === idid ? { ...section, Multiples: updatedMultiples } : section
        );
      });

      return updatedMultiples;
    });
  };

  // ✅ Prevent infinite update loops when switching steps
useEffect(() => {
  if (activeStep === 2) {
    setMultiples((prev) => {
      const needsUpdate = prev.some((item) => !item.value_hi && item.value);
      if (!needsUpdate) return prev; // nothing to update, skip

      const updated = prev.map((item) => ({
        ...item,
        value_hi: item.value_hi || item.value,
      }));

      // sync step1data2 only if changed
      setstep1data2((prevSections: any[]) => {
        let changed = false;
        const newSections = prevSections.map((section) => {
          if (section.id === idid) {
            const sectionChanged = JSON.stringify(section.Multiples) !== JSON.stringify(updated);
            if (sectionChanged) changed = true;
            return { ...section, Multiples: updated };
          }
          return section;
        });
        return changed ? newSections : prevSections;
      });

      return updated;
    });
  }
}, [activeStep, idid, setstep1data2]);


  const handleImageUpload = async (id: number, files: File | FileList | null, type: "small" | "big") => {
    if (!files) return;

    const formData = new FormData();
    let newPreviews: string[] = [];

    if (files instanceof FileList) {
      Array.from(files).forEach((file) => formData.append("answer", file));
      newPreviews = Array.from(files).map((file) => URL.createObjectURL(file));
    } else if (files instanceof File) {
      formData.append("answer", files);
      newPreviews = [URL.createObjectURL(files)];
    }

    try {
      const token = getToken();
      const response = await uploadimagetask(formData, token);
      if (response?.data?.answer) {
        const uploadedImagePaths = Array.isArray(response.data.answer)
          ? response.data.answer
          : [response.data.answer];
        const fullImageUrls = uploadedImagePaths.join(",");

        setImageMap((prev) => ({
          ...prev,
          [id]: {
            ...prev[id],
            [type === "small" ? "smallimage" : "bigimage"]: prev[id]?.[type === "small" ? "smallimage" : "bigimage"]
              ? [...prev[id][type === "small" ? "smallimage" : "bigimage"], ...newPreviews]
              : newPreviews,
          },
        }));

        setMultiples((prev) => {
          const updatedMultiples = prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  [type === "small" ? "smallimage" : "bigimage"]: item[type === "small" ? "smallimage" : "bigimage"]
                    ? `${item[type === "small" ? "smallimage" : "bigimage"]},${fullImageUrls}`
                    : fullImageUrls,
                  mainid: idid,
                }
              : item
          );

          setstep1data2((prevSections: any[]) => {
            const exists = prevSections.some((section) => section.id === idid);
            if (!exists) {
              return [...prevSections, { id: idid, Multiples: updatedMultiples }];
            }
            return prevSections.map((section) =>
              section.id === idid ? { ...section, Multiples: updatedMultiples } : section
            );
          });

          return updatedMultiples;
        });
      }
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const handleImageDelete = (id: number, index: number, type: "small" | "big") => {
    setImageMap((prev) => {
      if (!prev[id] || !prev[id][type === "small" ? "smallimage" : "bigimage"]) return prev;

      const updatedImages = prev[id][type === "small" ? "smallimage" : "bigimage"].filter((_, i) => i !== index);

      return {
        ...prev,
        [id]: {
          ...prev[id],
          [type === "small" ? "smallimage" : "bigimage"]: updatedImages,
        },
      };
    });

    setMultiples((prev) => {
      const updatedMultiples = prev.map((item) => {
        if (item.id === id) {
          const imageArray = item[type === "small" ? "smallimage" : "bigimage"]
            ? item[type === "small" ? "smallimage" : "bigimage"].split(",")
            : [];
          if (index >= 0 && index < imageArray.length) {
            imageArray.splice(index, 1);
          }
          return {
            ...item,
            [type === "small" ? "smallimage" : "bigimage"]: imageArray.join(","),
          };
        }
        return item;
      });

      setstep1data2((prevSections: any[]) => {
        const exists = prevSections.some((section) => section.id === idid);
        if (!exists) {
          return [...prevSections, { id: idid, Multiples: updatedMultiples }];
        }
        return prevSections.map((section) =>
          section.id === idid ? { ...section, Multiples: updatedMultiples } : section
        );
      });

      return updatedMultiples;
    });
  };

  const addInstruction = () => {
    const newId = multiples.length > 0 ? Math.max(...multiples.map((item) => item.id)) + 1 : 1;
    setMultiples((prev) => {
      const updatedMultiples = [...prev, { id: newId, value: "", value_hi: "", checkvalue: `check${newId}`, smallimage: "", bigimage: "", mainid: idid, ismatch: false }];

      setstep1data2((prevSections: any[]) => {
        const exists = prevSections.some((section) => section.id === idid);
        if (!exists) {
          return [...prevSections, { id: idid, Multiples: updatedMultiples }];
        }
        return prevSections.map((section) =>
          section.id === idid ? { ...section, Multiples: updatedMultiples } : section
        );
      });

      return updatedMultiples;
    });
  };

  const removeInstrucation = (id: number) => {
    setMultiples((prev) => {
      const updatedMultiples = prev.filter((multiple) => multiple.id !== id);

      setstep1data2((prevSections: any[]) => {
        const exists = prevSections.some((section) => section.id === idid);
        if (!exists) {
          return [...prevSections, { id: idid, Multiples: updatedMultiples }];
        }
        return prevSections.map((section) =>
          section.id === idid ? { ...section, Multiples: updatedMultiples } : section
        );
      });

      return updatedMultiples;
    });

    setImageMap((prev) => {
      const updatedImages = { ...prev };
      delete updatedImages[id];
      return updatedImages;
    });
  };

  const handleChangetext = (event: React.ChangeEvent<HTMLInputElement>) => {
    
    setText(event.target.value);
  };

  useEffect(() => {
  if (activeStep === 1 && correctHintArray.length > 0) {
    const hintForThisQuestion = correctHintArray.find(h => h.id === idid);
    setText(hintForThisQuestion?.value || "");
  } else if (activeStep === 2 && correctHintHiArray.length > 0) {
    const hintForThisQuestionHi = correctHintHiArray.find(h => h.id === idid);
    setText(hintForThisQuestionHi?.value || "");
  } else {
    setText(""); // fallback if no hint found
  }
}, [activeStep, correctHintArray, correctHintHiArray, idid]);



  const handleClick = (id: number, value: string, idid: number) => {
    setMultiples((prev) => {
  const updatedMultiples = prev.map((item) => {
      // only update match in step 1
      if (activeStep === 1) {
        return item.id === id
          ? { ...item, ismatch: true }
          : { ...item, ismatch: false };
      }

      // in step 2, keep old match state
      return item;
    });
      setstep1data2((prevSections: any[]) => {
        return prevSections.map((section) =>
          section.id === idid
            ? {
                ...section,
                Multiples: updatedMultiples,
                optionsslectedvalue: activeStep === 1 ? value : section.optionsslectedvalue,
                finalcorr: activeStep === 2 ? value : section.finalcorr,
              }
            : section
        );
      });

      return updatedMultiples;
    });


    setSelectedValue(String(id));
    setSelectedLabel(value);
    setSelectedId(id);
  };
    console.log(step1data2, "step1data2step1data233333",multiples,"multiplesmultiples")

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  const handleLabelChange = (value: string) => {
    setSelectedLabel(value);
  };

  const clickedItem = useRef<number>(0);
  const clickedItemHolder = useRef<number>(0);

  const handleSort = () => {
    setMultiples((prev) => {
      const dragList = [...prev];
      const temp = dragList[clickedItem.current];
      dragList[clickedItem.current] = dragList[clickedItemHolder.current];
      dragList[clickedItemHolder.current] = temp;

      setstep1data2((prevSections: any[]) => {
        const exists = prevSections.some((section) => section.id === idid);
        if (!exists) {
          return [...prevSections, { id: idid, Multiples: dragList }];
        }
        return prevSections.map((section) =>
          section.id === idid ? { ...section, Multiples: dragList } : section
        );
      });

      return dragList;
    });
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      <Box sx={{ width: "100%", marginLeft: "50px" }}>
        {bannerProps?.title && (
          <Box>
            {selectedmcq === "mcqimage" ? (
              <CreatetaskImg3
                mainIdd={idid}
                id={4}
                setIconImage={setIconImage}
                iconImage={iconImage}
                title={bannerProps.title}
                uploadText={bannerProps.uploadText}
                uploadSize={bannerProps.uploadSize}
                setuploadedImage={bannerProps.setuploadedImage}
                lang={lang}
              />
            ) : (
              <CreatetaskImg
                id={4}
                setIconImage={setIconImage}
                iconImage={iconImage}
                title={bannerProps.title}
                uploadText={bannerProps.uploadText}
                uploadSize={bannerProps.uploadSize}
                setuploadedImage={bannerProps.setuploadedImage}
                lang={lang}
              />
            )}
          </Box>
        )}
        <InstructionOne
          containerClassName={"multiple_single_instruction"}
          placeholderPrefix={lang.instruction}
          idid={idid}
          textvalue={textvalue}
          multiples={multiples}
          selectedValue={selectedValue}
          text={text}
          sectionsData1={sectionsData1.toString()}
          selectedLabel={selectedLabel}
          updateSectionsData2={(sectionId: number, selectedLabel: string | null) => {
            setstep1data2((prevSections: any[]) =>
              prevSections.map((section) =>
                section.id === sectionId
                  ? { ...section, optionsslectedvalue: selectedLabel ?? "" }
                  : section
              )
            );
          }}
          lang={lang}
        />
        {Tabname !== "Image Capture Task" && Tabname !== "छवि कैप्चर कार्य" &&
          multiples.map((instruction, index) => (
            <React.Fragment key={instruction.id}>
              <Box
                draggable
                onDragStart={() => (clickedItem.current = index)}
                onDragEnter={() => (clickedItemHolder.current = index)}
                onDragEnd={handleSort}
                onDragOver={(e) => e.preventDefault()}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "22px",
                }}
              >
                <span
                  style={{
                    cursor: "grabbing",
                    color: "#525252",
                    fontSize: "19px",
                  }}
                >
                  ⋮⋮
                </span>
                <Fileupload
                  fileuploadclass="instruction-upload"
                  iconSrc={galleryadd}
                  onFileSelect={(file) => handleImageUpload(instruction.id, file as File, "small")}
                  previewSize={{ width: 24, height: 24 }}
                  onRemoveFile={() => handleImageDelete(instruction.id, 0, "small")}
               previewImage={instruction.smallimage}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    width: "100%",
                  }}
                >
                  <Radio
                    sx={{
                      position: "absolute",
                      left: "0",
                      margin: "0",
                      zIndex: "1",
                    }}
                    disabled
                    checked={selectedValue === String(instruction.id)}
                    value={String(instruction.id)}
                    onChange={(event) => {
                      handleValueChange(event);
                      handleLabelChange(instruction.id === selectedId ? instruction.value : "");
                    }}
                    name="radio-buttons"
                    inputProps={{ "aria-label": `${instruction.id}` }}
                  />
                  <TextField
                    sx={{
                      ".MuiInputBase-input": {
                        padding: "16px 16px 16px 44px",
                        color: "#171717",
                        fontSize: "16px",
                        fontWeight: "500",
                        background: "#F9FBFC",
                        borderRadius: "10px",
                        width: "100%",
                      },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                    }}
                    id={`Instruction-${instruction.id}`}
                    placeholder={`${placeholderPrefix} ${instruction.id}`}
                    variant="outlined"
                    value={activeStep === 1 ? instruction.value : instruction.value_hi}
                    onChange={(e) => handleTextFieldChange(instruction.id, e.target.value)}
                  />
                </Box>
                <Tooltip title="Delete" arrow>
                  <span>
                    <Button
                      onClick={() => removeInstrucation(instruction.id)}
                      sx={{
                        border: "1px solid #F1F2F3",
                        padding: "16px",
                        borderRadius: "10px",
                        minWidth: "56px",
                        height: "56px",
                        "&:hover": { backgroundColor: "transparent !important" },
                        ".MuiTouchRipple-root": { display: "none" },
                      }}
                    >
                      <img
                        style={{ cursor: "pointer" }}
                        src={trash}
                        alt="trash"
                        height={24}
                        width={24}
                      />
                    </Button>
                  </span>
                </Tooltip>
              </Box>
              <Box
                className="showimages"
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  marginBottom: "22px",
                }}
              >
                {imageMap[instruction.id]?.bigimage?.map((preview, index) => (
                  <Box
                    key={index}
                    sx={{
                      position: "relative",
                      display: "inline-block",
                      minHeight: "unset",
                    }}
                  >
                    <img
                      src={preview}
                      alt={`Preview ${index}`}
                      style={{
                        width: "209px",
                        height: "209px",
                        margin: "5px",
                        border: "1px solid #E7E8E9",
                        borderRadius: "12px",
                      }}
                    />
                    <Button
                      onClick={() => handleImageDelete(instruction.id, index, "big")}
                      sx={{
                        position: "absolute",
                        top: "-5px",
                        right: "-5px",
                        backgroundColor: "#FFF",
                        borderRadius: "6px",
                        boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.10)",
                        width: "24px",
                        height: "24px",
                        minWidth: "unset",
                        padding: "0",
                      }}
                    >
                      <img
                        src={cancel}
                        alt="Delete"
                        style={{ width: "16px", height: "16px" }}
                      />
                    </Button>
                  </Box>
                ))}
              </Box>
            </React.Fragment>
          ))}
        {Tabname !== "Image Capture Task" && Tabname !== "छवि कैप्चर कार्य" && (
          <Button
            onClick={addInstruction}
            sx={{
              padding: "0",
              textTransform: "capitalize",
              fontSize: "14px",
              fontWeight: "500",
              color: "#C8172F",
            }}
          >
            <img style={{ marginRight: "8px" }} src={plus} alt="plus" /> {lang.addOptions}
          </Button>
        )}
        {Tabname !== "Image Capture Task" && Tabname !== "छवि कैप्चर कार्य" && (
          <Box sx={{ marginTop: "32px" }}>
            <Typography sx={{ fontSize: "18px", fontWeight: "600", color: "#282829" }} variant="body1">
              {lang.selectCorrectOptionHint}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "20px !important", padding: "20px 0 !important" }}>
              {multiples.map((item,index) => (
                <Box
                  key={item.id}
                  sx={{ display: "flex", alignItems: "center", gap: "20px", padding: "20px 0" }}
                >
                  <Box
                    sx={{
                      fontSize: "16px",
                      fontWeight: "500",
                      padding: "16px",
                      border: selectedId === item.id ? "1px solid #FEF1EF" : "1px solid #D1D5DB",
                      borderRadius: "10px",
                      height: "56px",
                      width: "56px",
                      textAlign: "center",
                      cursor: "pointer",
                      userSelect: "none",
                      transition: "background 0.3s ease-in-out, color 0.3s ease-in-out",
                      background: selectedId === item.id ? "#FEF1EF" : "#F9FBFC",
                      color: selectedId === item.id ? "#B90022" : "#000",
                    }}
                    onClick={() => handleClick(item.id, item.value, idid)}
                  >
                   {index + 1}
                  </Box>
                </Box>
              ))}
            </Box>
            <TextField
              sx={{
                ".MuiInputBase-input": {
                  padding: "16px",
                  color: "#171717",
                  fontSize: "16px",
                  fontWeight: "500",
                  background: "#F9FBFC",
                  borderRadius: "10px",
                  width: "100%",
                },
                ".MuiOutlinedInput-notchedOutline": {
                  borderColor: "transparent",
                },
              }}
              id="hint-input"
              placeholder={lang.writeHintCorrectOption}
              variant="outlined"
              value={text}
              onChange={handleChangetext}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MulitipleChoice;